// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Uq4WV","requiredAsterisk":"Info_requiredAsterisk__22ZaG"};